<template>
    <b-card>
        <template #header>
            Product Covers
            <div class="loader d-inline-block" v-if="isFetchingProducts"></div>
        </template>
        <b-input-group prepend="State:">
            <b-select v-model="mapProductState" @input="getStateProducts">
                <b-select-option v-for="(state, i) in states" :value="state.state">{{state.fullState}}</b-select-option>
            </b-select>
        </b-input-group>
        <multiselect id="sku"
                     v-if="stateProducts.length"
                     v-model="selectedProduct"
                     :options="stateProducts"
                     @input="getProductCover"
                     label="sku"
                     name="sku"
                     track-by="sku"
                     placeholder="Search Sku"
                     select-label=""
                     deselect-label=""
                     :searchable="true"
                     class=" w-100 d-inline-block"
        />

        <div v-if="selectedProduct" class="mt-2">
            <b-input-group prepend="New Cover:">
                <b-form-file v-model="newImage" accept="image/*" :multiple="false"></b-form-file>
                <template #append>
                    <b-btn variant="success" @click="addCover" :disabled="newImage == null || isFetchingProducts">
                        <font-awesome-icon :icon="['fas', 'plus']" /> Add Cover
                    </b-btn>
                </template>
            </b-input-group>
        </div>
        <div class="d-flex flex-wrap mt-2" v-if="productImages.length">
            <b-card v-for="(image, index) in productImages" :key="index" class="p-0 m-2">
                <b-card-img :src="imageUrl(image)" class="img-fluid p-0 m-0" style="max-height: 200px; max-width: 150px;" />
                <b-btn variant="danger" class="px-2 py-1 delete-btn" size="sm" @click="confirmDelete(image, index)" style="position: absolute; top: -5px;right: -5px; border:1px solid black; border-radius:15px;">
                    <font-awesome-icon :icon="['fas', 'trash']" />
                </b-btn>
            </b-card>
        </div>
    </b-card>
</template>

<script>
import states, {publicationStates} from "@/common/states";

export default {
    name: "ProductCoversAdmin",
    data: () => ({
        mapProductState: null,
        states: publicationStates,
        stateProducts: [],
        selectedProduct: null,
        productImages: [],
        isFetchingProducts: false,
        newImage: null,
    }),
    methods: {
        async getStateProducts() {
            this.productImages = [];
            this.isFetchingProducts = true;
            if (!this.mapProductState)
                return;

            let response = await this.axios.get(`/home/${this.mapProductState}/`);
            this.isFetchingProducts = false;
            this.stateProducts = response.data.publications;
        },
        async getProductCover()
        {
            this.productImages = [];
            if (!this.selectedProduct)
                return;

            this.isFetchingProducts = true;
            let response = await this.axios.get(`/images/cover/${this.selectedProduct.sku}/`);

            this.productImages = response.data;
            this.isFetchingProducts = false;
        },
        imageUrl(imageRelativePath) {
            let encoded = encodeURIComponent(imageRelativePath);
            return `https://cdn.studiesweekly.com/${encoded}`;
        },
        confirmDelete(item, index) {
            console.log('Confirm delete', item, index);
            if (confirm('Are you sure you want to delete this image? This action cannot be undone.')) {
                this.deleteImage(item, index);
            }
            else {
                // Cancelled
            }
        },
        async addCover() {
            if (!this.selectedProduct || !this.newImage)
                return;

            this.isFetchingProducts = true;
            let formData = new FormData();
            formData.append('image', this.newImage);

            try {
                let response = await this.axios.post(`/images/cover/${this.selectedProduct.sku}/`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                this.productImages.push(response.data);
                this.newImage = null;
            } catch (error) {
                console.error('Error uploading image:', error);
                alert('There was an error uploading the image. Please try again.');
            } finally {
                this.isFetchingProducts = false;
            }
        },
        async deleteImage(item, index) {
            if (!this.selectedProduct)
                return;

            this.isFetchingProducts = true;
            try {
                let response = await this.axios.delete(`/images/cover/${this.selectedProduct.sku}/`, {data: {image: item}});
                this.productImages.splice(index, 1);
            } catch (error) {
                console.error('Error deleting image:', error);
                alert('There was an error deleting the image. Please try again.');
            } finally {
                this.isFetchingProducts = false;
            }
        }
    }

}
</script>



<style scoped lang="scss">
.delete-btn {
    opacity: 0.25;
    filter: grayscale(0.7);
}
.delete-btn:hover {
    opacity: 1;
    filter: grayscale(0);
}
</style>